






























import { Component, Vue } from 'vue-property-decorator';
import { innerData } from './data';

@Component({
  name: 'InnerNews',
  components: {},
})
export default class extends Vue {
  page = {
    activePage: 1, // 当前页码
    pageSize: 10, // 每页显示的数量
    total: 0, // 总页数
  };
  innerData = innerData;

  // 获取当前页列表
  get getPageList(): Array<any> {
    return this.innerData.slice(
      (this.page.activePage - 1) * 10,
      this.page.activePage * 10
    );
  }

  // 获取总页数
  get getTotalPageCount(): number {
    return Math.floor(this.innerData.length / this.page.pageSize) + 1;
  }

  // 跳转至新闻详情
  showNewsDetail(id) {
    console.log('id: ', id);
    this.$router.push({
      name: 'NewsDetail',
      query: {
        id,
      },
    });
  }
}
